import React, { useEffect, useState } from "react"
import { Link, useLocation } from "react-router-dom"
import { Drawer, Switch } from "@mui/material"
// components
import { Button } from "@components/Button"
// hooks
import useAuth from "@hooks/useAuth"
// helpers
import { NAV_LINK } from "./helper"
// assets
import Logo from "@assets/Common/logo-black.png"
import { HamburgerCloseIcon, HamburgerMenuIcon } from "@assets/icons"
import useProfile from "@hooks/useProfile"
import { useSelector } from "react-redux"

export const AppDrawer = () => {
    // states
    const [drawerOpen, setDrawerOpen] = useState(false)
    const { handleGetOwnDetails } = useProfile()
    const { profileDetails } = useSelector((state) => state.profile)

    // hooks
    const { handleLogoutSession } = useAuth()
    const location = useLocation()

    // handler
    const handleSignOut = () => {
        handleLogoutSession()
    }

    const toggleDrawer = (open) => (event) => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return
        }
        setDrawerOpen(open)
    }

    useEffect(() => {
        handleGetOwnDetails()
    }, [])

    // Drawer content
    const drawerContent = (
        <div
            className="flex flex-col justify-between h-full w-80 px-4 py-10"
            role="presentation"
        >
            <div className="flex flex-col gap-8">
                <div className="flex items-center justify-end">
                    <HamburgerCloseIcon
                        onClick={toggleDrawer(false)}
                        className="size-8"
                    />
                </div>
                <div className="flex flex-col">
                    {NAV_LINK.map((link) => (
                        <Link
                            to={link.path}
                            key={link.key}
                            className={`group flex items-center gap-4 ext-base px-4 py-3.5 text-[var(--text-nav)] rounded-lg hover:text-[var(--text-theme)] hover:bg-[var(--bg-blue-light)] ${location.pathname === link.path ? "text-[var(--text-theme)] bg-[var(--bg-blue-light)]" : ""}`}
                        >
                            <link.icon className="size-6" />

                            {link.title}
                        </Link>
                    ))}
                </div>
            </div>
            <div className="flex flex-col gap-5">
                {/* <div className="flex items-center justify-center gap-1 h-12 rounded-lg bg-[#EAEAEA80]">
                    <Switch />
                    <span className="text-sm font-medium">VR Mode Off</span>
                </div> */}
                <div className="flex items-center justify-between gap-3">
                    <div className="flex flex-col gap-0.5">
                        <span className="text-sm leading-4 font-bold">
                            {profileDetails?.local?.firstName}{" "}
                            {profileDetails?.local?.lastName}
                        </span>
                        <span className="text-xs leading-4">
                            {profileDetails?.local?.email}
                        </span>
                    </div>
                    <Button
                        variant="secondary"
                        onClick={handleSignOut}
                        size="sm"
                    >
                        Sign Out
                    </Button>
                </div>
            </div>
        </div>
    )

    return (
        <>
            <div className="flex sm:hidden items-center justify-between h-full w-full px-5 lg:px-10 xl:px-14 2xl:px-20 py-5 3xl:py-10">
                <div className="flex items-center">
                    <img src={Logo} height="auto" width={132} alt="logo" />
                </div>

                <HamburgerMenuIcon
                    className="size-8"
                    onClick={toggleDrawer(true)}
                />
            </div>
            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={toggleDrawer(false)}
            >
                {drawerContent}
            </Drawer>
        </>
    )
}
